import { FIELD_TYPE_FLOAT, FIELD_TYPE_INTEGER } from '../constants';


var floatRegexAllowTrailingPeriod = /^[-+]?[0-9]*\.?[0-9]*$/;
var floatRegex = /^[-+]?[0-9]*\.?[0-9]+$/;
var integerRegex = /^[-+]?[0-9]+$/;

var floatValidatorAllowTrailingPeriod = function floatValidatorAllowTrailingPeriod(value) {
    return !!value.match(floatRegexAllowTrailingPeriod);
};
var floatValidator = function floatValidator(value) {
    return !!value.match(floatRegex);
};
var integerValidator = function integerValidator(value) {
    return !!value.match(integerRegex);
};

var isValidValue = function isValidValue(type, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (type === FIELD_TYPE_FLOAT && typeof value === 'string') {
        return options.allowTrailingPeriod ? floatValidatorAllowTrailingPeriod(value) : floatValidator(value);
    }

    if (type === FIELD_TYPE_INTEGER && typeof value === 'string') {
        return integerValidator(value);
    }

    return true;
};

export { isValidValue };
import { bpfrpt_proptype_FieldValue } from '../flowTypes';